import VOBResponse from './VOBResponse';

export default VOBResponse;
